module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/invalid-727e6f162fc27e7fd4bb93a657a8d9d3.svg";